module.exports = __webpack_public_path__ + "static/couple-playing-basketball-desktop.4c113863.webp";